import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../../services/rest/rest.service';
import { RestResponse } from '../../../services/rest/rest.domain';
import { Suggestions } from './suggested-for-you.domain';

@Injectable({
  providedIn: 'root'
})
export class SuggestedForYouRestService {
  private static readonly NEW_TO_WB_SUGGESTION_ID: number = 11;
  private readonly restService = inject(RestService);

  getSuggestedForYouList(): Observable<Array<Suggestions> | undefined> {
    return this.restService.getResource('suggestedForYou.list')
      .get<Array<Suggestions>>()
      .pipe(
        map((response: Array<Suggestions>): Array<Suggestions> | undefined => {
          if (response !== undefined) {
            const suggestions = response.sort(this.compare);
            if (suggestions?.length > 0) {
              const newToWbIndex = suggestions.findIndex((suggestion: Suggestions) => suggestion.suggestionId === SuggestedForYouRestService.NEW_TO_WB_SUGGESTION_ID);
              if (newToWbIndex > -1) {
                suggestions.unshift(suggestions.splice(newToWbIndex, 1)[0]);
              }
            }
            return suggestions;
          }
        })
      );
  }

  markViewed(suggestionId: number, actionIndicator: number):  Observable<RestResponse<unknown>> {
    const body = {
      suggestion: {
        suggestionId,
        actionIndicator
      }
    };
    return this.restService.getResource('suggestedForYou.markViewed').post(body);
  }

  private compare(a: Suggestions, b: Suggestions): number {
    if (a.priority < b.priority) {
      return -1;
    }
    if (a.priority > b.priority) {
      return 1;
    }
    return 0;
  }
}

